import { render } from "./SvgSprite.vue?vue&type=template&id=a86264aa&ts=true"
import script from "./SvgSprite.vue?vue&type=script&lang=ts"
export * from "./SvgSprite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__